import { _request,APIBaseResponse, APIMethod } from '../index';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const ROLE_CLAIM_PATH_PREFIX = 'roleclaimmemberships';

type APIRoleClaimMembershipListParams = RequestParamsBase & {
    tenantId: string;
    roleId: string;
}

type APIRoleClaimMembershipListResponse = APIBaseResponse<
    Array<{
        claimDataTypeId: string;
        claimDataTypeName: string;
        claimId: string;
        claimName: string;
        claimValue: string;
        roleId: string;
        roleName: string;
    }>
>

export type APIRoleClaimMembershipPostParams = {
    tenantId: string;
    roleId: string;
    claimId: string;
    claimValue: string;
}

export type APIRoleClaimMembershipPutParams = {
    tenantId: string;
    roleId: string;
    claimId: string;
    claimValue: string;
}

export type APIRoleClaimMembershipPostResponse = APIBaseResponse<string>;
export type APIRoleClaimMembershipPutResponse = APIBaseResponse<string>;

export const APIRoleClaimMembershipGetList: APIMethod<APIRoleClaimMembershipListParams, APIRoleClaimMembershipListResponse> = params => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ROLE_CLAIM_PATH_PREFIX}?roleId=${params.roleId}`, undefined, params.signal)
);

export const APIRoleClaimMembershipPost: APIMethod<APIRoleClaimMembershipPostParams, APIRoleClaimMembershipPostResponse> = (params) => (
    _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ROLE_CLAIM_PATH_PREFIX}`, params)
);

export const APIRoleClaimMembershipPut: APIMethod<APIRoleClaimMembershipPutParams, APIRoleClaimMembershipPutResponse> = (params) => (
    _request('PUT', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ROLE_CLAIM_PATH_PREFIX}`, params)
);

type APIRoleClaimMembershipDeleteParams = {
    tenantId: string;
    roleId: string;
    claimId: string;
}

export const APIRoleClaimMembershipDelete: APIMethod<APIRoleClaimMembershipDeleteParams, APIBaseResponse> = (params: APIRoleClaimMembershipDeleteParams) => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ROLE_CLAIM_PATH_PREFIX}?roleId=${params.roleId}&claimId=${params.claimId}`)
);
